<template>
	<div class="dimmed"></div>
	<div ref="searchModal" class="btn_search">
		<div :class="'search_box'">
			<div class="header_favorite">
				<span>관심종목</span>
				<CloseIcon @click="onClickbtn" />
			</div>
			<InterestStockMenu />
		</div>
	</div>
</template>
<script setup lang="ts">
import { onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

import CloseIcon from '@/assets/img/common/clear.svg?component';
import { useDisplayStore } from '@/stores/display';
import { closeMenuModal } from '@/utils/function/modalMenu';

import InterestStockMenu from './InterestStockMenu.vue';

// -----variable-----
const route = useRoute();
const displayStore = useDisplayStore();

const searchModal = ref();

document.body.classList.add('hidden');

// -----function-----
// 검색 창 유무
const onClickbtn = () => {
	closeMenuModal();
};

//외부 클릭 시, 검색 창 닫힘 기능
onClickOutside(searchModal, () => {
	if (route.query.isInterestMenuOpen && displayStore.isDesktop) onClickbtn();
});

// 화면 나갔을 경우, 스크롤 방지 기능 삭제
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style lang="scss" scoped>
.header_favorite {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	font-size: var(--font-s-large);
	font-weight: var(--font-w-bold);
	line-height: 25px;
}

.btn_search {
	position: relative;
	.search_box {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 5rem;
		right: -7rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		gap: 3.55rem;
		padding: 1.95rem 2rem 1.6rem 2rem;
	}
	.search_box_mobile {
		position: absolute;
		z-index: 85;
		background-color: var(--color-bg);
		top: 7rem;
		right: -5.5rem;
		display: flex;
		flex-direction: column;
		width: 37.5rem;
		border-radius: var(--border-radius-small);
		align-items: flex-end;
		gap: 1rem;
		padding: 1.6rem 2rem;
	}
}
.dimmed {
	position: fixed;
	background-color: rgba(45, 45, 45, 0.3);
	top: 0px;
	left: 0px;
	height: 100%;
	width: 100%;
	z-index: 80;
}
</style>
